import { useCallback } from 'react';

export const useValidationActKC2 = (isRequiredField: boolean) => {
    const validateByStatus = useCallback(
        (value) => {
            if (isRequiredField && value) {
                return true;
            }

            if (isRequiredField && !value) {
                return 'Поле обязательно для заполнения';
            }

            return true;
        },
        [isRequiredField],
    );

    const validateDateRange = useCallback(
        (value) => {
            if (isRequiredField && (!value || value.includes(undefined) || value.includes(null))) {
                return 'Поле обязательно для заполнения';
            }

            return true;
        },
        [isRequiredField],
    );

    return {
        validateByStatus,
        validateDateRange,
    };
};
